var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEmail = function SvgEmail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#324D5B",
    d: "M50 0C22.386 0 0 22.386 0 50s22.386 50 50 50 50-22.387 50-50S77.614 0 50 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B424D",
    d: "M19 82.998v-56L.188 45.811A50 50 0 0 0 0 50c0 12.649 4.707 24.192 12.452 32.999H19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA9C44",
    d: "M89 81.272V57L49.975 38 11 57v24.272C20.164 92.687 34.224 100 50 100s29.836-7.313 39-18.728"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M19 27h63a2 2 0 0 1 2 2v46a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V29a2 2 0 0 1 2-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#26A6D1",
    d: "M38 32h7l4-5h-7zm30-5-4 5h7l4-5zm-51 2v3h3l4-5h-5a2 2 0 0 0-2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2574C",
    d: "M51 32h7l4-5h-7zm-26 0h7l4-5h-7zm57-5h-1l-4 5h7v-3a2 2 0 0 0-2-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE1E2",
    d: "M73.5 47h-17a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 1 0 0-3m-3 6h-14a1.5 1.5 0 0 0 0 3h14a1.5 1.5 0 0 0 0-3m-31.483-4.04.682 3.585L34 43.999l-8 12c0 1.105 5.148 2 11.5 2s11.5-.895 11.5-2l-7-10zM40 43.999a2 2 0 1 0-.001-4.001A2 2 0 0 0 40 43.999M56.5 44h17a1.5 1.5 0 1 0 0-3h-17a1.5 1.5 0 1 0 0 3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B459",
    d: "M89 81.272V57L49.975 75.999 11 57v24.272C20.164 92.687 34.224 100 50 100s29.836-7.313 39-18.728"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6C37A",
    d: "M89 57 20.591 90.427A49.76 49.76 0 0 0 49.983 100h.034C65.786 99.994 79.84 92.682 89 81.272z"
  })));
};
export default SvgEmail;